/** Галочка и радиокнопка окон инструментов: на телефоне цель 44px. */
export function Choice({
  type = 'checkbox',
  label,
  checked,
  onChange,
  name,
  disabled = false,
}: {
  type?: 'checkbox' | 'radio'
  label: string
  checked: boolean
  onChange: (value: boolean) => void
  name?: string
  disabled?: boolean
}) {
  return (
    <label
      className={`flex min-h-11 items-center gap-2.5 text-sm desk:min-h-8 ${disabled ? 'opacity-50' : 'cursor-pointer'}`}
    >
      <input
        type={type}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="size-4 shrink-0 accent-[var(--accent)]"
      />
      {label}
    </label>
  )
}
